import {generateTokensFromObject} from '../__utils';

import {typography as baseTypography, ui as baseUI} from './xLarge';
import {fontFamilyTokens, remify} from './_shared';
import type {Sizing} from './_shared';

/**
 * Creates a new set of tokens for Branded.
 * This is a (temporary) solution to address the need for a new set of tokens
 * for Branded.
 *
 * This is a copy of `xLarge` with the following changes:
 * - fontSize.body: 14
 *
 * @see https://webflow.slack.com/archives/C012XUU5EQL/p1709831692726699
 *
 * 2024-03-07
 */
const typography: Sizing['typography'] = {
  ...baseTypography,
  fontFamily: {
    ...baseTypography.fontFamily,
    // sansSerif and display are being set to branded here to seamlessly integrate Spring into Branded vibes.
    sansSerif: fontFamilyTokens.branded,
    display: fontFamilyTokens.branded,
    title: fontFamilyTokens.branded,
    heading: fontFamilyTokens.branded,
    body: fontFamilyTokens.branded,
    helpText: fontFamilyTokens.branded,
    code: fontFamilyTokens.mono,
  },
  fontWeight: {
    ...baseTypography.fontWeight,
    normal: 400,
    medium: 500,
    semibold: 600,
  },
  fontSize: {
    ...baseTypography.fontSize,
    heading: remify(16),
    body: remify(14),
  },
  lineHeight: {
    ...baseTypography.lineHeight,
    heading: '160%',
    body: '24px',
    helpText: '16px',
    code: '24px',
  },
} as const;

export const ui: Sizing['ui'] = baseUI;

const sizingValues = {
  typography,
  ui,
};

export const {setTokens: xLargeBrandedVars} = generateTokensFromObject(
  sizingValues,
  {applyNamespace: true}
);
